<section class="chronos-dialog--size-xs">
  <div class="warehouse-change-modal">
    <div class="warehouse-change-modal__container">
      <div class="p-grid">
        <div class="p-col-6 center-items">
          <label [for]="'change_quantity_input'" class="warehouse-change-modal__container-label">
            {{ 'Warehouse' | translate }}
          </label>
        </div>
        <div class="p-col-6 center-items">
          <p-dropdown
            [placeholder]="'WORK_CENTER_SCREEN.DROPDOWN_DEFAULT_LABEL' | translate"
            [options]="warehouseList"
            appendTo="body"
            [dropdownIcon]="isLoading ? 'pi pi-spin pi-spinner' : 'pi pi-chevron-down'"
            [(ngModel)]="warehouseId"
            (onChange)="onWarehouseChange($event)"
          />
        </div>
      </div>
      <div class="p-grid">
        <div class="p-col-6 center-items">
          <label [for]="'change_quantity_input'" class="warehouse-change-modal__container-label">
            {{ 'Warehouse Location' | translate }}
          </label>
        </div>
        <div class="p-col-6 center-items">
          <p-dropdown
            appendTo="body"
            [placeholder]="'WORK_CENTER_SCREEN.DROPDOWN_DEFAULT_LABEL' | translate"
            [options]="warehouseLocationList"
            [(ngModel)]="warehouseLocationId"
            [dropdownIcon]="isLoading ? 'pi pi-spin pi-spinner' : 'pi pi-chevron-down'"
            (onChange)="onWarehouseLocationChange($event.value)"
            [disabled]="warehouseLocationList.length <= 0"
          ></p-dropdown>
        </div>
      </div>
    </div>
  </div>
  <lib-modal-footer
    (submitClicked)="submitModal()"
    (declineClicked)="closeModal()"
    [submitDisabled]="!isValid"
    [whenLoadingTopic]="LOADING_TOPIC_SAVEWORKCENTER"
  ></lib-modal-footer>
</section>
